import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { ClientType } from '../../api';
import { clientInitials } from '../../helpers/personaUtils';
import { getClientTypeColors } from '../../theme/ataTheme';

const useStyles = makeStyles({
    avatar: {
        display: 'grid',
        placeItems: 'center',
        fontWeight: tokens.fontWeightBold,
        flex: 'none',
    },
    medium: {
        width: '32px',
        height: '32px',
        borderRadius: '8px',
        fontSize: '12px',
    },
    small: {
        width: '24px',
        height: '24px',
        borderRadius: '6px',
        fontSize: '10px',
    },
    large: {
        width: '48px',
        height: '48px',
        borderRadius: '11px',
        fontSize: '16px',
    },
});

interface ClientAvatarProps {
    name: string;
    clientType?: ClientType | string;
    size?: 'small' | 'medium' | 'large';
    className?: string;
}

/**
 * Square, rounded avatar showing a client's initials in its type's color pair.
 */
const ClientAvatar = ({ name, clientType, size = 'medium', className }: ClientAvatarProps) => {
    const styles = useStyles();
    const colors = getClientTypeColors(clientType);

    return (
        <div
            className={mergeClasses(styles.avatar, styles[size], className)}
            style={{ backgroundColor: colors.tint, color: colors.text }}
            aria-hidden
        >
            {clientInitials(name)}
        </div>
    );
};

export default ClientAvatar;
